import { render } from "./part.vue?vue&type=template&id=5211b675&ts=true"
import script from "./part.vue?vue&type=script&lang=ts"
export * from "./part.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__